import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { Pagination } from '../models/request.model';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { User } from '../models/user.model';
import { ApiProviderService } from './api-provider.service';

@Injectable({ providedIn: 'root' })
export class UserManagementService implements IBaryTableFetchService<User> {
  private resourceUrl = API_ENDPOINTS.ADMIN_USER_MANAGEMENT;

  constructor(private apiProvider: ApiProviderService) {}

  fillDataToShow(entities: User[]): Observable<User[]> {
    return of(entities);
  }

  create(user: User): Observable<HttpResponse<User>> {
    return this.apiProvider.post<User>(this.resourceUrl, user);
  }

  update(user: User): Observable<User> {
    return this.apiProvider.put<User>(this.resourceUrl, user).pipe(mapAsBody);
  }

  find(login: string): Observable<User> {
    return this.apiProvider.get<User>(`${this.resourceUrl}/${login}`).pipe(mapAsBody);
  }

  query(req?: Pagination): Observable<HttpResponse<User[]>> {
    const options = createRequestOption(req);
    return this.apiProvider.get<User[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(login: string): Observable<{}> {
    return this.apiProvider.delete(`${this.resourceUrl}/${login}`);
  }

  deleteById(id: number): Observable<{}> {
    return this.apiProvider.delete(`${this.resourceUrl}/id/${id}`);
  }

  authorities(): Observable<string[]> {
    return this.apiProvider.get<string[]>(`${this.resourceUrl}/authorities`).pipe(mapAsBody);
  }
}
